import React, {useState} from "react";
import {useRouteMatch} from "react-router";
import {NavLink as Link} from "react-router-dom";

function MenuItems(props) {
  const { url } = useRouteMatch();
  const menu = props.Items;
  const [exapnd, setExpand] = useState(false);
  return (
    <li
      onClick={() => setExpand(!exapnd)}
      className={`menu-item ${exapnd ? "open" : ""}`}
    >
      <a className={`menu-link ${exapnd ? "active" : ""}`} href="#_">
        <span className="material-icons">{menu.MaterialIcon}</span>
        <span className="title">{menu.name}</span>
        <span className="arrow material-icons" />
      </a>
      {menu.submenu ? (
        <ul className="menu-submenu">
          {menu.submenu.map((sub, index) => (
            <li className="menu-item" key={index}>
              <Link
                className="menu-link"
                to={`${url}/${menu.name.replace(
                  /[.*+?^${}()&;|[\]\\|\s]/g,
                  ""
                )}/${sub.name.replace(/[.*+?^${}()&;|[\]\\|\s]/g, "")}`}
              >
                <span className="dot" />
                <span className="title">{sub.name}</span>
              </Link>
            </li>
          ))}
        </ul>
      ) : (
        ""
      )}
    </li>
  );
}
export default React.memo(MenuItems);
